/**
 * icon font的名字映射表
 */
export default {
  'play-circle': '\ue8a1',
  'check-circle': '\ue86f',
  keyboard: '\ue870',
  risk: '\ue871',
  'quick-arrival': '\ue872',
  receipt: '\ue873',
  'status-default': '\ue874',
  link: '\ue875',
  swap: '\ue876',
  'password-manage': '\ue877',
  notice: '\ue878',
  'search-no': '\ue879',
  'status-success': '\ue87a',
  locate: '\ue87b',
  idea: '\ue87c',
  rise: '\ue87d',
  'message-center': '\ue87e',
  'transaction-limits': '\ue87f',
  'remove-outline': '\ue880',
  recycle: '\ue881',
  scan: '\ue882',
  remind: '\ue883',
  'line-chart': '\ue884',
  'status-error': '\ue885',
  'transaction-details': '\ue886',
  refresh: '\ue887',
  user: '\ue888',
  table: '\ue889',
  safe: '\ue88a',
  'qr-code': '\ue88b',
  loading: '\ue88c',
  'remove-circle': '\ue88d',
  up: '\ue88e',
  'touch-id': '\ue88f',
  smile: '\ue890',
  security: '\ue891',
  transfer: '\ue892',
  'waiting-outline': '\ue893',
  'treasure-chart': '\ue894',
  'smile-circle': '\ue895',
  share: '\ue896',
  waiting: '\ue897',
  'user-circle': '\ue898',
  'subscript-selected': '\ue899',
  review: '\ue89a',
  voice: '\ue89b',
  treasure: '\ue89c',
  swift: '\ue89d',
  'wechat-circle': '\ue89e',
  write: '\ue89f',
  'wechat-pay-outline': '\ue8a0',
  'account-analysis': '\ue819',
  'account-setting': '\ue81a',
  add: '\ue81b',
  'about-us': '\ue81c',
  'account-info': '\ue81d',
  back: '\ue81e',
  'alert-circle-outline': '\ue81f',
  'add-circle-outline': '\ue820',
  approval: '\ue821',
  backspace: '\ue822',
  'bar-chart': '\ue823',
  atm: '\ue824',
  'check-circle-outline': '\ue825',
  'bank-card': '\ue826',
  'check-list': '\ue827',
  car: '\ue828',
  bank: '\ue829',
  contacts: '\ue82a',
  'close-circle-outline': '\ue82b',
  'currency-exchange': '\ue82c',
  'checkbox-outline': '\ue82d',
  'add-user': '\ue82e',
  'card-manage': '\ue82f',
  'confirm-circle': '\ue830',
  'checkbox-unchecked': '\ue831',
  'charge-no': '\ue832',
  'daily-interest': '\ue833',
  danger: '\ue834',
  'ccy-code': '\ue835',
  'deal-list': '\ue836',
  'bell-outline': '\ue837',
  'deal-certificate': '\ue838',
  coupon: '\ue839',
  down: '\ue83a',
  checkbox: '\ue83b',
  download: '\ue83c',
  copy: '\ue83d',
  'direction-right': '\ue83e',
  disavowal: '\ue83f',
  'eye-open': '\ue840',
  'email-circle': '\ue841',
  'error-circle': '\ue842',
  evaluating: '\ue843',
  facebook: '\ue844',
  close: '\ue845',
  financial: '\ue846',
  'fps-free': '\ue847',
  'fps-easy': '\ue848',
  contract: '\ue849',
  flashlight: '\ue84a',
  fall: '\ue84b',
  'fps-fast': '\ue84c',
  home: '\ue84d',
  'diamond-circle': '\ue84e',
  list: '\ue84f',
  'address-book': '\ue850',
  exchange: '\ue851',
  'fixed-deposit': '\ue852',
  'face-id': '\ue853',
  'eye-close': '\ue854',
  'quick-circulate': '\ue855',
  picture: '\ue856',
  'more-dotted': '\ue857',
  'correspondent-bank': '\ue858',
  gathering: '\ue859',
  'radio-unchecked': '\ue85a',
  'fps-checked': '\ue85b',
  check: '\ue85c',
  identity: '\ue85d',
  'more-dotted-horizontal': '\ue85e',
  earnings: '\ue85f',
  'question-circle-outline': '\ue860',
  more: '\ue861',
  questionnaire: '\ue862',
  calculator: '\ue863',
  'customer-service': '\ue864',
  'create-account-outline': '\ue865',
  camera: '\ue866',
  'fps-id': '\ue867',
  radio: '\ue868',
  navigation: '\ue869',
  edit: '\ue86a',
  phone: '\ue86b',
  search: '\ue86c',
  'line-chart-circle': '\ue86d',
  'limit-outline': '\ue86e',
};
